import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ErrorPageComponent } from '../app/components/error-page/error-page.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'reza-not-found',
  template: `
    <reza-error-page
      errorTitle="404 Stránka nebyla nalezena"
      perex="Omlouváme se, stránka, kterou chcete otevřít, neexistuje."
      text="Je možné, že byla odstraněna, přejmenována anebo je dočasně nepřístupná."
      image="../../assets/error-404.svg">
      <a class="p-button" type="button" routerLink="/">
        <i class="pi pi-home mr-1.5"></i>
        Přejít na domovskou obrazovku
      </a>
    </reza-error-page>
  `,
  imports: [ErrorPageComponent, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPageComponent {}
